import { Helmet } from 'react-helmet-async';

export default function SEO({ title, description, image, type = 'website' }) {
    const siteName = 'Université de Tous Âges Nord-Luxembourg (Barvaux-sur-Ourthe)';
    const defaultDescription = 'Université de Tous Âges Nord-Luxembourg (Barvaux-sur-Ourthe). Conférences, excursions et activités culturelles pour tous.';
    const defaultImage = 'https://images.unsplash.com/photo-1524178232363-1fb2b075b655?q=80&w=1200&auto=format&fit=crop';

    const fullTitle = title ? `${title} | ${siteName}` : siteName;

    return (
        <Helmet>
            {/* Standard Metadata */}
            <title>{fullTitle}</title>
            <meta name="description" content={description || defaultDescription} />

            {/* Open Graph / Facebook */}
            <meta property="og:type" content={type} />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={description || defaultDescription} />
            <meta property="og:image" content={image || defaultImage} />
            <meta property="og:site_name" content={siteName} />

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={fullTitle} />
            <meta name="twitter:description" content={description || defaultDescription} />
            <meta name="twitter:image" content={image || defaultImage} />
        </Helmet>
    );
}
